var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-us-container"},[_c('div',{staticClass:"image-container"},_vm._l((_vm.imageList),function(item,index){return _c('div',{key:index,staticClass:"row"},[_c('img',{attrs:{"src":item}})])}),0),_c('viewFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }